export default __webpack_public_path__ + "static/media/status-not-available-icon.8d511a09.svg";